import { Input } from "design-system/atoms/Input"
import { Label } from "design-system/atoms/Label"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { WorkflowActionDisableAgentConfigSchema, WorkflowNodeSchema } from "schema"
import z from "zod"
import { useWorkflowBuilder } from "../../hooks/useWorkflowBuilder"

type Props = {
  nodeIndex: number
  node: Extract<z.infer<typeof WorkflowNodeSchema>, { type: "Action" }>
}

export function DisableAgentConfiguration({ nodeIndex, node }: Props) {
  const { t } = useTranslation()
  const { form } = useWorkflowBuilder()

  useEffect(() => {
    if (WorkflowActionDisableAgentConfigSchema.safeParse(node.config).success) return

    form.setValue(`nodes.${nodeIndex}.config`, { hours: 24 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const hours = form.watch(`nodes.${nodeIndex}.config.hours`)

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1.5">
        <Label>{t("campaigns.action.availableActions.DisableAgent.config.duration")}</Label>
        <Input
          type="number"
          min="1"
          rightText={t("campaigns.action.availableActions.DisableAgent.config.hours")}
          value={typeof hours === "number" && Number.isFinite(hours) ? hours : ""}
          onChange={(event) => {
            form.setValue(
              `nodes.${nodeIndex}.config`,
              { hours: event.target.valueAsNumber },
              { shouldDirty: true },
            )
            form.trigger(`nodes.${nodeIndex}.config`)
          }}
        />
      </div>
      <p className="text-sm text-muted-foreground">
        {t("campaigns.action.availableActions.DisableAgent.config.description")}
      </p>
    </div>
  )
}
